var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('toolbar',{attrs:{"transparent":"","fixed":"","logo":false,"back":false},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('div',{staticClass:"v-toolbar__button",on:{"click":_vm.confirmExit}},[_c('v-icon',{attrs:{"icon":"close"}})],1)]},proxy:true}])}),_c('alert-dialog',{attrs:{"title":"Leave workout?","actions":[
      {
        title: 'No, continue',
        callback: _vm.resume
      },
      {
        title: 'Finish Workout',
        callback: _vm.complete
      }
    ],"show":_vm.showDialog},on:{"close":_vm.resume}},[_vm._v(" Are you sure you want to exit this workout in progress? ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }